import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import SlidellHeroSection from "./components/HeroSection";
import SlidellStickyNav from "./components/StickyNav";
import SlidellProcessingTimeSection from "./components/ProcessingTimeSection";
import SlidellServicesSection from "./components/ServicesSection";
import SlidellLocalAreaSection from "./components/LocalAreaSection";
import SlidellTravelTimingSection from "./components/TravelTimingSection";
import SlidellDestinationsSection from "./components/DestinationsSection";
import SlidellTestimonialsSection from "./components/TestimonialsSection";
import SlidellAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SlidellComparisonSection from "./components/ComparisonSection";
import SlidellMistakesSection from "./components/MistakesSection";
import SlidellHowItWorksSection from "./components/HowItWorksSection";
import SlidellFAQSection, { faqs } from "./components/FAQSection";
import SlidellHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SlidellFinalCTA from "./components/FinalCTA";

export default function SlidellPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Slidell"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/slidell"
        title="Emergency Passport Slidell, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Slidell, LA — as fast as 24 hours. Serving Northshore families, commuters, and Gulf Coast travelers in St. Tammany Parish. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Slidell, Louisiana"
        geoPosition="30.2749;-89.7812"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <SlidellHeroSection />
      <SlidellStickyNav />
      <SlidellProcessingTimeSection />
      <SlidellServicesSection />
      <SlidellLocalAreaSection />
      <SlidellTravelTimingSection />
      <SlidellDestinationsSection />
      <SlidellTestimonialsSection />
      <SlidellAcceptanceFacilitiesSection />
      <SlidellComparisonSection />
      <SlidellMistakesSection />
      <SlidellHowItWorksSection />
      <SlidellFAQSection />
      <SlidellHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/slidell" state="LA" />
      <SlidellFinalCTA />
    </div>
  );
}